import produce from 'immer';

import {
  FETCH_CASE_WORKLOAD_REPORTS_FAILURE,
  FETCH_CASE_WORKLOAD_REPORTS_SUCCESS,
  FETCH_CLOSED_CASES_REPORTS_FAILURE,
  FETCH_CLOSED_CASES_REPORTS_SUCCESS,
  FETCH_OPEN_CASES_REPORTS_FAILURE,
  FETCH_OPEN_CASES_REPORTS_SUCCESS,
  FETCH_TOTAL_CASES_REPORTS_FAILURE,
  FETCH_TOTAL_CASES_REPORTS_SUCCESS,
  FETCH_VIOLATION_REPORTS_FAILURE,
  FETCH_VIOLATION_REPORTS_SUCCESS,
} from '@actions/xerceReports';

const initialState: IXerceReportsStore = {
  totalCaseReport: null,
  openedCaseReport: null,
  closedCaseReport: null,
  caseWorkloadReport: null,
  violationReport: null,
  error: null,
};

export default (state: IXerceReportsStore = initialState, action: any) =>
  produce(state, (draftState: IXerceReportsStore) => {
    switch (action.type) {
      case FETCH_OPEN_CASES_REPORTS_SUCCESS:
        draftState.openedCaseReport = action.response;
        draftState.error = null;

        return;

      case FETCH_CASE_WORKLOAD_REPORTS_SUCCESS:
        draftState.caseWorkloadReport = action.response;
        draftState.error = null;

        return;

      case FETCH_VIOLATION_REPORTS_SUCCESS:
        draftState.violationReport = action.response;
        draftState.error = null;

        return;

      case FETCH_OPEN_CASES_REPORTS_FAILURE:
        draftState.openedCaseReport = null;
        draftState.error = action.error;

        return;

      case FETCH_VIOLATION_REPORTS_FAILURE:
        draftState.violationReport = null;
        draftState.error = action.error;

        return;

      case FETCH_CASE_WORKLOAD_REPORTS_FAILURE:
        draftState.caseWorkloadReport = null;
        draftState.error = action.error;

        return;

      case FETCH_CLOSED_CASES_REPORTS_SUCCESS:
        draftState.closedCaseReport = action.response;
        draftState.error = null;

        return;

      case FETCH_CLOSED_CASES_REPORTS_FAILURE:
        draftState.closedCaseReport = null;
        draftState.error = action.error;

        return;

      case FETCH_TOTAL_CASES_REPORTS_SUCCESS:
        draftState.totalCaseReport = action.response;
        draftState.error = null;

        return;

      case FETCH_TOTAL_CASES_REPORTS_FAILURE:
        draftState.totalCaseReport = null;
        draftState.error = action.error;

        return;

      default:
        return;
    }
  });
